module.exports = __webpack_public_path__ + "img/logo_brainsre.f91a45e3.png";